import createMockup from "../assets/Create.png";
import creatorSmall from "../assets/CreatorSmall.png";
import prayAccent from "../assets/Pray.png";

const CreateChallengesSection = () => {
  return (
    <section className="bg-white overflow-hidden">
      <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8 py-14 md:py-20 lg:py-[100px] xl:py-28 2xl:py-32">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-[50px] xl:gap-16 2xl:gap-20">
          <div
            className="w-full lg:w-[40%] 2xl:w-[38%] flex flex-col items-center lg:items-start text-center lg:text-left"
            style={{ maxWidth: "611px" }}
          >
            <h3 className="text-[38px] leading-[46px] sm:text-[44px] sm:leading-[54px] lg:text-[65px] lg:leading-[80px] font-bold text-[#0B0D0B]">
              Create. Compete. Earn.
            </h3>
            <p className="mt-4 lg:mt-5 text-lg leading-7 sm:text-xl sm:leading-8 lg:text-[28px] lg:leading-[38px] text-[#0B0D0B]">
              Weekly challenges with real rewards. Show up, stand out, and get
              paid for your creativity.
            </p>

          </div>

          <div className="w-full lg:w-[60%] 2xl:w-[62%] flex justify-center relative lg:pl-1 xl:pl-3">
            <img
              src={createMockup}
              alt="Create. Compete. Earn."
              className="w-full max-w-[360px] sm:max-w-[420px] md:max-w-[460px] lg:max-w-[520px] xl:max-w-[560px] 2xl:max-w-[600px] object-contain"
            />

            <div className="hidden lg:block absolute top-2 right-8 xl:right-10 2xl:right-12 w-[110px] h-[60px] xl:w-[130px] xl:h-[72px] 2xl:w-[148px] 2xl:h-[82px]">
              <img
                src={prayAccent}
                alt=""
                aria-hidden="true"
                className="w-full h-full object-contain object-center opacity-95"
              />
            </div>

            <div className="hidden lg:block absolute bottom-4 left-[-40px] xl:left-[-40px] 2xl:left-[-76px] w-[320px] h-[190px] xl:w-[360px] xl:h-[214px] 2xl:w-[400px] 2xl:h-[238px]">
              <img
                src={creatorSmall}
                alt=""
                aria-hidden="true"
                className="w-full h-full object-contain object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreateChallengesSection;
